import * as PopoverPrimitive from '@radix-ui/react-popover';
import { PopoverContent } from './PopoverContent';
export const Popover = {
  Root: PopoverPrimitive.Root,
  Content: PopoverContent,
  Trigger: PopoverPrimitive.Trigger,
  Portal: PopoverPrimitive.Portal,
  Anchor: PopoverPrimitive.Anchor,
  Arrow: PopoverPrimitive.Arrow
};